Array.prototype.asyncReduce = async function (cb, initialValue) {
  for (let i = 0; i < this.length; i++) {
    initialValue = await cb(initialValue, this[i]);
  }

  return initialValue;
};
